<template>
  <div>
    <h1 class="display-4">Modifier son mot de passe</h1>
    <hr />

    <div class="alert alert-info">
      Si vous changez votre mot de passe sur EventDB, votre mot de passe sur le support IONIS ne sera pas affecté.
    </div>

    <form>
      <div class="form-group">
        <label for="old_password">Ancien mot de passe</label>
        <input type="password" class="form-control" id="old_password" placeholder="Votre ancien mot de passe" v-model="old_password">
        <div class="alert alert-danger mt-3" v-show="error_form.old_password">
          {{ message.old_password }}
        </div>
      </div>
      <div class="form-group">
        <label for="new_password">Nouveau mot de passe</label>
        <input type="password" class="form-control" id="new_password" placeholder="Votre nouveau mot de passe" v-model="new_password">
        <div class="alert alert-danger mt-3" v-show="error_form.new_password">
          {{ message.new_password }}
        </div>
      </div>
      <div class="form-group">
        <label for="new_password_confirm">Confirmation du mot de passe</label>
        <input type="password" class="form-control" id="new_password_confirm" placeholder="Confirmez votre nouveau mot de passe" v-model="new_password_confirm">
        <div class="alert alert-danger mt-3" v-show="error_form.new_password_confirm">
          {{ message.new_password_confirm }}
        </div>
      </div>
      <button type="submit" class="btn btn-primary" @click.prevent="update">Modifier son mot de passe</button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      error_form: {},
      message: {},
      new_password: '',
      new_password_confirm: '',
      old_password: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain'])
  },
  methods: {
    update () {
      this.error_form = {}
      this.message = {}

      if (this.old_password !== '' && this.new_password !== '' && this.new_password_confirm !== '') {
        if (this.new_password === this.new_password_confirm) {
          this.$http.post(this.domain + '/api/ionis/change-password?access_token=' + this.access_token, { oldPassword: this.old_password, newPassword: this.new_password }, { emulateJSON: true }).then((response) => {
            if (response.status === 204 && response.ok) {
              this.new_password = ''
              this.new_password_confirm = ''
              this.old_password = ''
              // this.flash('Votre mot de passe a bien été modifié', 'success', { timeout: 3000 })
              this.$root.$bvToast.toast('Votre mot de passe a bien été modifié', {
                title: 'Mot de passe modifié',
                autoHideDelay: 3000,
                append: false,
                variant: 'success'
              })
            }
          }, (response) => {
            if (response.status === 400) {
              this.error_form.old_password = true
              this.message.old_password = 'Votre mot de passe actuel est incorrect'
              this.old_password = ''
              document.getElementById('old_password').focus()
            }
          })
        } else {
          this.error_form.new_password_confirm = true
          this.message.new_password_confirm = 'Les mots de passe ne correspondent pas'
        }
      } else {
        if (this.old_password === '') {
          this.error_form.old_password = true
          this.message.old_password = 'Vous devez renseigner ce champ'
        }
        if (this.new_password === '') {
          this.error_form.new_password = true
          this.message.new_password = 'Vous devez renseigner ce champ'
        }
        if (this.new_password_confirm === '') {
          this.error_form.new_password_confirm = true
          this.message.new_password_confirm = 'Vous devez renseigner ce champ'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Password.vue